import { extendObservable, computed, action } from 'mobx';
import autobind from 'autobind-decorator';
import { timeUtils } from 'utils/timeUtil';

@autobind
class TennisModel {
  constructor(data) {
    extendObservable(this, data);
  }

  @computed
  get quarterArr() {
    let quarters = [
      { key: '1Q', value: 1 },
      { key: '2Q', value: 2 },
      { key: '3Q', value: 3 },
      { key: '4Q', value: 4 }
    ];

    const { period } = this;

    if (period > 4) {
      quarters.push({
        key: `연장`,
        value: 5
      });
    }

    return quarters;
  }

  @computed
  get getStartDateTime() {
    return timeUtils.timeFormatHourMinute(this.startDatetime);
  }

  @computed
  get getTracker() {
    const gameStatus = this.gameStatus;

    if (
      gameStatus === 'IN_PROGRESS' ||
      gameStatus === 'BREAK_TIME' ||
      gameStatus === 'PAUSE'
    ) {
      return { status: 'progress', class: '' };
    } else if (
      gameStatus === 'FINAL' ||
      gameStatus === 'CUT' ||
      gameStatus === 'POSTPONED' ||
      gameStatus === 'PENDING' ||
      gameStatus === 'CANCEL' ||
      gameStatus === 'DELAY' ||
      gameStatus === 'SUSPENDED'
    ) {
      return { status: 'final', class: 'close' };
    } else {
      // READY
      return { status: 'ready', class: 'wait' };
    }
  }

  @computed
  get statusText() {
    const { gameStatus, period } = this;
    let statusText = '';

    if (gameStatus === 'CANCEL') {
      statusText = '취소';
    } else if (gameStatus === 'DELAY' || gameStatus === 'POSTPONED') {
      statusText = '연기';
    } else if (gameStatus === 'BREAK_TIME') {
      statusText = 'HT';
    } else if (gameStatus === 'PAUSE') {
      statusText = '중지';
    } else if (gameStatus === 'PENDING' || gameStatus === 'CUT') {
      statusText = '중단';
    } else if (gameStatus === 'READY') {
      statusText = '시작전';
    } else if (gameStatus === 'FINAL') {
      statusText = '종료';
    } else if (gameStatus === 'IN_PROGRESS') {
      if (period > 4) {
        statusText = '연장';
      } else {
        statusText = `${period}Q`;
      }
    }

    return statusText;
  }

  /**********************************************************
   * actions
   **********************************************************/
  @action
  updateGame(data) {
    for (const [key, value] of Object.entries(data)) {
      if (key === 'teams') {
        this.teams = {
          ...this.teams,
          ...value,
          home: {
            ...this.teams.home,
            ...value.home
          },
          away: {
            ...this.teams.away,
            ...value.away
          }
        };
      } else {
        this[key] = value;
      }
      // console.log(`${key}: ${value}`);
    }
  }
}

export default TennisModel;
